import { useEffect, useState } from "react";
import { api, getUser } from "@/lib/api";
import StationHome from "@/pages/StationHome";

/**
 * Envolve uma rota, garantindo que o usuário logado tem `perm`.
 * - Admin real (role=admin, is_station=false): sempre passa.
 * - Estações/operadores: consulta /permissions/me. Se não tem `perm`,
 *   renderiza StationHome no modo "denied".
 *
 * Uso: <Route path="/kanban" element={<PermGate perm="kanban"><KanbanBoard/></PermGate>} />
 */
export default function PermGate({ perm, children }) {
  const user = getUser();
  const [state, setState] = useState({ ready: false, allowed: true });

  useEffect(() => {
    // Admin real: bypass instantâneo, sem chamada extra.
    if (user?.role === "admin" && !user?.is_station) {
      setState({ ready: true, allowed: true });
      return;
    }
    let cancel = false;
    api.get("/permissions/me")
      .then(({ data }) => {
        if (cancel) return;
        const perms = data?.permissions || {};
        setState({ ready: true, allowed: !!perms[perm] });
      })
      .catch(() => { if (!cancel) setState({ ready: true, allowed: false }); });
    return () => { cancel = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [perm]);

  if (!state.ready) {
    return <div className="p-10 text-zinc-400" data-testid="perm-gate-loading">Carregando…</div>;
  }
  if (!state.allowed) {
    return <StationHome mode="denied" />;
  }
  return children;
}
